import React from "react";

import { Button, Modal, useManualModalState } from "@synthesis/shared-ui";

import { useStores } from "../../../store";

interface AddModalDeleteFolderProps {
  deleteId?: string;
}

interface ModalDeleteFolderProps extends AddModalDeleteFolderProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openModal: () => void;
  closeModal: () => void;
}

const ModalDeleteFolder = React.memo((props: ModalDeleteFolderProps) => {
  const { deleteId } = props;
  return (
    <Modal.Root manual {...props}>
      <AddModalDeleteFolder deleteId={deleteId} />
    </Modal.Root>
  );
});

const AddModalDeleteFolder = React.memo(({ deleteId }: AddModalDeleteFolderProps) => {
  const { directoryStore } = useStores();
  const { closeModal } = useManualModalState();

  const handleConfirm = () => {
    if (deleteId) {
      directoryStore.deleteDirectory(deleteId);
    }
    closeModal();
  };

  return (
    <Modal.Content className="w-[35vw] min-w-[350px]">
      <Modal.Title>Удаление папки</Modal.Title>
      <div className="px-5 pb-2">
        <h2 className="mt-2">Вы уверены, что хотите безвозвратно удалить эту папку?</h2>
        <div className="flex content-center gap-2 py-2">
          <Button theme="primary" type="button" onClick={handleConfirm}>
            Удалить папку
          </Button>
          <Button type="button" onClick={closeModal}>
            Отменить
          </Button>
        </div>
      </div>
    </Modal.Content>
  );
});

export default ModalDeleteFolder;
